// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsViewSampleCentric_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5798 6.47748 8.26078 10.9923C8.1737 10.9999 8.08555 11.0038 7.9965 11.0038 7.529 11.0038 7.08647 10.8968 6.69204 10.7061L3.99774 13.4004C4.17581 14.0677 4.00326 14.8091 3.47984 15.3325 2.69885 16.1135 1.43245 16.1135.651412 15.3325-.129625 14.5515-.129582 13.2851.651412 12.5041 1.17484 11.9807 1.91621 11.8081 2.58353 11.9862L5.2836 9.28611C5.13052 8.96282 5.03352 8.6078 5.00517 8.23359L3.39939 7.78428C2.90516 8.26674 2.17444 8.47994 1.46159 8.28048.397948 7.98287-.223152 6.87924.0744777 5.81554.372108 4.75185 1.47578 4.13082 2.53942 4.42843 3.25227 4.6279 3.76623 5.18937 3.9383 5.85826L5.52532 6.30232C5.56527 6.24441 5.6072 6.18797 5.65102 6.13311 5.95774 5.74905 6.35681 5.44198 6.81461 5.24556L6.51728 3.90862C5.85866 3.70069 5.32574 3.15718 5.16505 2.4346 4.92528 1.35644 5.60497.287902 6.68318.0481191 6.75057.0331326 6.81792.0217382 6.88503.0138085 7.89172-.105137 8.84487.555484 9.06966 1.56625 9.0797 1.61141 9.08813 1.65656 9.09499 1.70162 9.19781 2.37762 8.94623 3.0362 8.46959 3.47445L8.83618 5.12287C8.9922 5.16827 9.14297 5.226 9.28737 5.29493 9.82663 5.55237 10.277 5.96609 10.5798 6.47748ZM8.9965 8.00378C8.9965 8.55606 8.54878 9.00378 7.9965 9.00378 7.44422 9.00378 6.9965 8.55606 6.9965 8.00378 6.9965 7.45149 7.44422 7.00378 7.9965 7.00378L8.00297 7.0038C8.55227 7.00728 8.9965 7.45365 8.9965 8.00378ZM13.1053 15.7911 13 16 10 10 13 4 16 10 13.1053 15.7911ZM13 12.9992 14.5 10H11.5L13 12.9992Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsViewSampleCentric is a generated icon component.
 */
let IconRmsViewSampleCentric = IconRmsViewSampleCentric_1 = class IconRmsViewSampleCentric extends IconBaseElement {
    render() {
        return html `${IconRmsViewSampleCentric_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsViewSampleCentric.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconRmsViewSampleCentric = IconRmsViewSampleCentric_1 = __decorate([
    customElement('zui-icon-rms-view-sample-centric')
], IconRmsViewSampleCentric);
export { IconRmsViewSampleCentric };
